export default __webpack_public_path__ + "static/media/girl-hostel-4.8c23ed8a.jpg";